module.exports = __webpack_public_path__ + "media/images/guy_floating_shadow-427c031dcf68ff20d43244d1371cdad9.png";